import styled from 'styled-components';

export const StyledRepairOrderList = styled.div`
    display: flex;
    flex-direction: column;
`;

export const StyledRepairOrderCard = styled.article`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem 0;

    &:not(:last-child) {
        border-bottom: 1px solid #cecfd1;
    }
`;

export const StyledRepairOrderHeadline = styled.header`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 1rem;

    > :first-child {
        min-width: 0;
        overflow-wrap: anywhere;
    }

    > :last-child {
        flex-shrink: 0;
        white-space: nowrap;
    }
`;

export const StyledRepairOrderField = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 1rem;

    > :last-child {
        text-align: right;
    }
`;

/* Block, not flex: a flex parent blockifies its `li` children, which drops their list markers. */
export const StyledRepairOrderServices = styled.ul`
    margin: 0;
    padding-left: 1.25rem;
    list-style: disc outside;
`;

export const StyledRepairOrderServiceRow = styled.li`
    display: list-item;

    &:not(:last-child) {
        margin-bottom: 0.25rem;
    }
`;

export const StyledRepairOrderServiceRowContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 1rem;

    > :last-child {
        text-align: right;
        white-space: nowrap;
    }
`;
